import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { IApplicableLargeEmployeeDetails } from './applicableLargeEmployeeDetails';
import { Http, Response, Headers } from '@angular/http';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class ApplicableLargeEmployeeDetailsService {

    private _aleUrl = CONFIGURATION.baseDataBoardingUrl + 'aledetailsservice/';

    constructor(private _http: Http) { }

    addAleDetails(newObj: IApplicableLargeEmployeeDetails) {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Client-Id', 'DATA-ONBOARDING-API-CLIENT');
        headers.append('Client-Secret', 'e8f0c303-581e-4095-834f-f8828ff89890');
        const content = JSON.stringify(newObj);

        return this._http.post(this._aleUrl + 'addaledetails', content, {
            headers: headers
        }).map((response: Response) => response.json())
            .catch(this.handleError);
    }

    removeAleDetails(id: string, detailsId: string, taxYear: string): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'DATA-ONBOARDING-API-CLIENT');
        headers.append('Client-Secret', 'e8f0c303-581e-4095-834f-f8828ff89890');
        headers.append('Content-Type', 'application/json');
        headers.append('AleId', id);
        headers.append('AleDetailsId', detailsId);
        headers.append('AleTaxYear', taxYear);
        const content = JSON.stringify({ AleId: id, AleDetailsId: detailsId, AleTaxYear: taxYear });

        return this._http.put(this._aleUrl + 'deletealedetails', content, { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }

    updateAleDetails(obj: IApplicableLargeEmployeeDetails) {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Client-Id', 'DATA-ONBOARDING-API-CLIENT');
        headers.append('Client-Secret', 'e8f0c303-581e-4095-834f-f8828ff89890');
        const content = JSON.stringify(obj);

        return this._http.put(this._aleUrl + 'updatealedetails', content, {
            headers: headers
        }).map((response: Response) => response.json())
            .catch(this.handleError);
    }

    getAleDetailsById(id: string, detailsId: string, taxYear: string): Observable<IApplicableLargeEmployeeDetails> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Client-Id', 'DATA-ONBOARDING-API-CLIENT');
        return this._http.get(this._aleUrl + 'loadaledetails?AleId=' + id + '&AleDetailsId=' + detailsId + '&AleTaxYear=' + taxYear,{headers:headers})
            .map((response: Response) => response.json().aceDetails)
            .catch(this.handleError);
    }

    
    getAllAleDetails(): Observable<IApplicableLargeEmployeeDetails[]> {
        const headers = new Headers();
        headers.append('Client-Id', 'DATA-ONBOARDING-API-CLIENT');
        headers.append('Client-Secret', 'e8f0c303-581e-4095-834f-f8828ff89890');
        return this._http.get(this._aleUrl + 'loadallaledetails',{headers:headers})
            .map((response: Response) => response.json().aleDetailsData)
            .catch(this.handleError);
    }

    getAleMap(){
        const headers = new Headers();
        headers.append('Client-Id', 'DATA-ONBOARDING-API-CLIENT');
        headers.append('Client-Secret', 'e8f0c303-581e-4095-834f-f8828ff89890');
        return this._http.get(CONFIGURATION.baseDataBoardingUrl + 'aleservice/' + 'loadallalemap',{headers:headers})
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }

    getControlGroupMap(){
        const headers = new Headers();
        headers.append('Client-Id', 'DATA-ONBOARDING-API-CLIENT');
        headers.append('Client-Secret', 'e8f0c303-581e-4095-834f-f8828ff89890');
        return this._http.get(CONFIGURATION.baseDataBoardingUrl + 'controlgroupservice/' + 'loadallcontrolgroupmap',{headers:headers})
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }
}



// WEBPACK FOOTER //
// ./src/app/ApplicableLargeEmployeeDetails/applicableLargeEmployeeDetails.service.ts